import React, {Component} from 'react'
import {connect} from 'react-redux'
import {FJSaveAction} from "../../../redux/action/FJRoot.action";
import FJLogo from "../view/FJLogo";

class FJLogoContainer extends Component {

  /**
   * @description 点击logo跳转首页
   * @private
   */
  _gotoUserProjects = () => {
    this.props.checkIsSave(() => {
      window.location.href = '/';
    });
  };

  render() {
    return <FJLogo onClick={this._gotoUserProjects} />
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    checkIsSave: function (callback) {
      dispatch(FJSaveAction.checkIsSaveAction(callback))
    }
  }
};

export default connect(null, mapDispatchToProps)(FJLogoContainer);